import React, { useState, useEffect } from 'react'

const ModalWrapper = ({ isOpen, onClose, title, children, className = '' }) => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
                     window.innerWidth < 768
      setIsMobile(mobile)
    }
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  if (!isOpen) return null

  return (
    <div className={`fixed inset-0 ${isMobile ? 'bg-black/80' : 'bg-black/50 backdrop-blur-sm'} flex items-center justify-center z-50 p-4`}>
      <div className={`${isMobile ? 'bg-slate-900/95' : 'bg-white/10 backdrop-blur-xl'} rounded-2xl shadow-2xl border border-white/20 p-6 w-full max-w-lg ${className}`}>
        <h3 className="text-lg font-semibold text-white mb-4">
          {title}
        </h3>
        {children}
      </div>
    </div>
  )
}

export const ModalActions = ({ onCancel, onSave, cancelText = 'Cancel', saveText = 'Save Changes' }) => (
  <div className="flex gap-3 justify-end mt-6">
    <button
      type="button"
      onClick={onCancel}
      className="px-4 py-2 bg-white/10 hover:bg-white/20 text-white font-medium rounded-lg border border-white/20 hover:border-white/40 transition-all duration-300"
    >
      {cancelText}
    </button>
    <button
      type="button"
      onClick={onSave}
      className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white font-medium rounded-lg transition-all duration-300"
    >
      {saveText}
    </button>
  </div>
)

export default ModalWrapper